import { Injectable } from '@angular/core';
import { ActionsForItemService, convertMessageToHtml, DataListItemAction } from '@selfai-platform/shell';
import { ModelsRegistryListItem, ModelsRegistryVersionsListItem } from '@selfai-platform/pipeline-api';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest, map, Observable } from 'rxjs';
import { ModelsRegistryPermissionAction } from '@selfai-platform/shared';
import { ModelsRegistryPermissionService } from './models-registry-permission.service';
import { ModelsRegistryVersionsListDomainService } from './models-registry-versions-list-domain.service';
import { ModelsRegistryVersionsListDataService } from '../store/models-registry-versions-list-data.service';
import { ModelsRegistryVersionsListStore } from '../store/models-registry-versions-list.store';

@Injectable({
  providedIn: 'root',
})
export class ModelsRegistryVersionsActionsForItemsService extends ActionsForItemService<ModelsRegistryVersionsListItem> {
  public ref: DynamicDialogRef | undefined;
  constructor(
    private readonly modelsVersionsListDomainService: ModelsRegistryVersionsListDomainService,
    private readonly modelsRegistryVersionsDataService: ModelsRegistryVersionsListDataService,
    private readonly modelsRegistryVersionsListStore: ModelsRegistryVersionsListStore,
    private readonly confirmationService: ConfirmationService,
    private readonly translateService: TranslateService,
    private readonly permissionService: ModelsRegistryPermissionService,
  ) {
    super();
  }

  override getActionsForItem(model: ModelsRegistryVersionsListItem): Observable<DataListItemAction[]> {
    return combineLatest({
      deleteTooltipTranslate: this.translateService.get('models-registry-list.actions.delete'),
      deletePermission: this.permissionService.checkPermission(ModelsRegistryPermissionAction.Delete),
    }).pipe(
      map(({ deleteTooltipTranslate, deletePermission }) => {
        if (deletePermission) {
          return [
            {
              labelTranslate: deleteTooltipTranslate,
              icon: 'pi pi-trash',
              action: () => this.delete(model),
            },
          ] as DataListItemAction[];
        } else {
          return [];
        }
      }),
    );
  }

  private delete(modelRegistryVersionListItem: ModelsRegistryListItem): void {
    this.confirmationService.confirm({
      key: 'dialog',
      message: convertMessageToHtml(
        this.translateService.instant('models-registry-versions-list.actions.delete.confirmation'),
      ),
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.modelsVersionsListDomainService.deleteModelVersion(modelRegistryVersionListItem.id);
      },
    });
  }
}
